import React from 'react';
import {Tabs} from "antd";
import InvoiceComponentPT from "./InvoicePT";
import InvoiceComponentFK from "./InvoiceFK";

const Invoice = () => {

    const items = [
        {
            key: 'tab1',
            label: 'Visa/Mastercard EU',
            children: <InvoiceComponentPT />,
        },
        {
            key: 'tab2',
            label: 'Freekassa',
            children: <InvoiceComponentFK />,
        },
    ];

    return <Tabs defaultActiveKey="tab1" items={items} />;
};

export default Invoice;